/**
 * The account's streak (ADR 0051): cumulative, not consecutive — a day
 * missed takes nothing away. A day counts at the first daily contract paid;
 * each pays a small reward on a seven-day cycle, the character who paid the
 * contract receives it, and the seventh day also brings the Light Fox, a pet
 * never sold nor found, once per account: the streak never falls back, so
 * its seventh day comes only once.
 */
/** Day 1 to 7 of each week of the streak; the seventh is the best. */
export const STREAK_CYCLE = [
    { gold: 25, items: [] },
    { gold: 0, items: [{ templateId: 'potion-small', quantity: 3 }] },
    { gold: 50, items: [] },
    { gold: 0, items: [{ templateId: 'potion-medium', quantity: 2 }] },
    { gold: 75, items: [] },
    { gold: 0, items: [{ templateId: 'potion-medium', quantity: 3 }] },
    { gold: 150, items: [] },
];
export const STREAK_PET_DAY = 7;
export const STREAK_PET_ITEM = 'light-fox';
//# sourceMappingURL=streak.js.map